import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import moment from 'moment';

declare var $: any;

export class BaseComponent {
    listStatus = ['received', 'analysis', 'approved', 'denied', 'awarded', 'approved_award'];
    statusKamban = ['pending', 'in progress', 'done', 'canceled'];
    enumVote = ['not attend', 'parctially attends', 'attend', 'overcomes'];
    enumSustainability = ['water', 'energy', 'waste'];
    order = ['name', 'createdAt'];
    dateNow = new Date();
    labels: any = {
        previousLabel: '',
        nextLabel: '',
        screenReaderPaginationLabel: 'Pagination',
        screenReaderPageLabel: 'page',
        screenReaderCurrentLabel: `You're on page`
    };


    constructor(public router: Router,
        public loading: NgxSpinnerService,
        public translate: TranslateService) {
    }

    setToken(token: string) {
        // Token em sessionStorage: a sessão é encerrada ao fechar a aba/janela.
        sessionStorage.setItem('token', token);
    }

    setCulture(culture: string) {
        localStorage.setItem('culture', culture);
    }

    getBaseURL() {
        return environment.base_url;
    }

    switchLanguage(language: string) {
        if (language === 'pt') {
            language = 'pt';
            this.setCulture('pt-BR');
        } else if (language === 'en') {
            language = 'en';
            this.setCulture('en-US');
        } else if (language === 'es') {
            language = 'es';
            this.setCulture('es-ES');
        }
        this.translate.use(language);
    }

    handlerConfirm() {
        $('#modalNoteResume').modal('show');
    }

    showMessage(t: string, m: string, type: any = 'warning') {
        Swal.fire({
            title: t,
            html: m,
            icon: type,
            confirmButtonColor: '#032E58',
        });
    }

    confirmMessage(t: string, m: string, callback: any = null) {
        Swal.fire({
            title: t,
            text: m,
            icon: 'warning',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
            confirmButtonColor: '#032E58',
            cancelButtonColor: '#dc3545'
        }).then((result) => {
            if (!this.isNullOrUndefined(result.value) && result.value === true) {
                if (callback != null) {
                    callback();
                }
            }
        });
    }

    confirmMessageKaizen(t: string, m: string, confirmButtonColor: string = '#032E58', cancelButtonColor: string = '#dc3545', callback: any = null) {
        Swal.fire({
            title: t,
            text: m,
            icon: 'warning',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Não',
            cancelButtonText: 'Sim',
            confirmButtonColor: confirmButtonColor,
            cancelButtonColor: cancelButtonColor
        }).then((result) => {
            if (!this.isNullOrUndefined(result.value) && result.value === true) {
                if (callback != null) {
                    callback();
                }
            }
        });
    }


    showModal(idModal) {
        $('#' + idModal).modal('show');
    }

    closeModal(idModal) {
        $('#' + idModal).modal('hide');
    }

    onError(error) {
        this.loading.hide();
        if (error.status === 401) {
            this.router.navigate(['/authenticate']);
            return;
        }

        // const e = JSON.parse(error['error']);

        if (error.status === 400) {
            this.showMessage(this.translate.instant('baseComponent.warningAttention'), error.error.message, 'warning');
            return;
        }

        if (error.status === 500) {
            this.showMessage(this.translate.instant('baseComponent.warningAttention'), this.translate.instant('baseComponent.warningMsgError'), 'warning');
            return;
        }
    }

    isNullOrUndefined(value, object = false) {
        if (object) {
            return typeof value === 'undefined' || value == null;
        }
        return typeof value === 'undefined' || value == null || value.length === 0;
    }

    validateField(obj) {
        let strError = ``;
        obj.map((e) => {
            if (this.isNullOrUndefined(e.value)) {
                strError += `${e.text}`;
            }
        });
        return strError;
    }

    handlerFlagImage(value) {
        switch (value) {
            case 'Chile':
                return 'chile.svg';
            case 'Peru':
                return 'peru.svg';
            case 'Bolívia':
                return 'bolivia.svg';
            case 'Venezuela':
                return 'venezuela.svg';
            case 'Argentina':
                return 'argentina.svg';
            case 'México':
                return 'mexico.svg';
            case 'Equador':
                return 'equador.svg';
            case 'Guatemala':
                return 'guatemala.svg';
            case 'Brazil':
                return 'brazil.svg';
            case 'Colômbia':
                return 'colombia.svg';
            case 'Uruguai':
                return 'uruguay.svg';
            case 'Paraguay':
                return 'paraguay.svg';
        }
    }

    handlerStepBar(value) {

        switch (value) {
            case 1:
                return 'width: 0%';
            case 2:
                return 'width: 25%';
            case 3:
                return 'width: 50%';
            case 4:
                return 'width: 75%';
            case 5:
                return 'width: 100%';
        }
    }

    handlerLanguage(model) {
        switch (model) {
            case 'open':
                if (this.translate.currentLang === 'pt') {
                    return 'Aberto';
                } else {
                    return 'abierto';
                }
            case 'approve':
                if (this.translate.currentLang === 'pt') {
                    return 'Aprovado';
                } else {
                    return 'Aprobado';
                }
            case 'disapprove':
                if (this.translate.currentLang === 'pt') {
                    return 'Reprovado';
                } else {
                    return 'Desaprobado';
                }
            case 1:
                if (this.translate.currentLang === 'pt') {
                    return 'Comercial local';
                } else {
                    return 'Negocio local';
                }
            case 2:
                if (this.translate.currentLang === 'pt') {
                    return 'AR Local';
                } else {
                    return 'AR Local';
                }
            case 3:
                if (this.translate.currentLang === 'pt') {
                    return 'AR International';
                } else {
                    return 'AR Internacional';
                }
            case 4:
                if (this.translate.currentLang === 'pt') {
                    return 'Artes';
                } else {
                    return 'Letras';
                }
            case 5:
                if (this.translate.currentLang === 'pt') {
                    return 'Cadastro';
                } else {
                    return 'Registrarse';
                }
        }
    }

    getMonthNames() {
        let arrMonth = [];
        switch (this.translate.currentLang) {
            case 'en':
                arrMonth = [
                    'January',
                    'February',
                    'March',
                    'April',
                    'May',
                    'June',
                    'July',
                    'August',
                    'September',
                    'October',
                    'November',
                    'December'
                ];
                break;
            case 'es':
                arrMonth = [
                    'Enero',
                    'Febrero',
                    'Marzo',
                    'Abril',
                    'Mayo',
                    'Junio',
                    'Julio',
                    'Agosto',
                    'Septiembre',
                    'Octubre',
                    'Noviembre',
                    'Deciembre'
                ];
                break;
            default:
                arrMonth = [
                    'Janeiro',
                    'Fevereiro',
                    'Março',
                    'Abril',
                    'Maio',
                    'Junho',
                    'Julho',
                    'Agosto',
                    'Setembro',
                    'Outubro',
                    'Novembro',
                    'Dezembro'
                ];
                break;
        }
        return arrMonth;
    }

    getDaysOfDayWeek() {
        let arr = [];
        switch (this.translate.currentLang) {
            case 'en':
                arr = [
                    'Sun',
                    'Mon',
                    'Tue',
                    'Wed',
                    'Thu',
                    'Fri',
                    'Sat'
                ];
                break;
            case 'es':
                arr = [
                    'Dom',
                    'lun',
                    'mar',
                    'mie',
                    'jue',
                    'vie',
                    'Sab'
                ];
                break;
            default:
                arr = [
                    'Dom',
                    'Seg',
                    'Ter',
                    'Qua',
                    'Qui',
                    'Sex',
                    'Sab'
                ];
                break;
        }
        return arr;
    }

    setDatePicker(id: string, callback, date = 29) {
        $('.' + id).daterangepicker({
            startDate: moment().utcOffset(0).subtract(date, 'days'),
            cancelButtonClasses: 'btn-danger',
            ranges: {
                Hoje: [moment(), moment()],
                Ontem: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                '7 Dias': [moment().subtract(6, 'days'), moment()],
                '30 Dias': [moment().subtract(29, 'days'), moment()],
                '60 Dias': [moment().subtract(59, 'days'), moment()],
                '90 Dias': [moment().subtract(89, 'days'), moment()],

            },
            locale: {
                customRangeLabel: 'Personalizar',
                format: 'DD/MM/YYYY',
                separator: ' - ',
                applyLabel: 'Aplicar',
                cancelLabel: 'Cancelar',
                monthNames: this.getMonthNames(),
                daysOfWeek: this.getDaysOfDayWeek(),
                firstDay: 1
            }
        }, callback);
    }

    setDate(id: string, callback, startDate = undefined) {
        $('.' + id).daterangepicker({
            startDate: startDate ? moment(startDate).utc() : moment(),
            singleDatePicker: true,
            cancelButtonClasses: 'btn-danger',
            locale: {
                customRangeLabel: 'Personalizar',
                format: 'DD/MM/YYYY',
                separator: ' - ',
                applyLabel: 'Aplicar',
                cancelLabel: 'Cancelar',
                monthNames: this.getMonthNames(),
                daysOfWeek: this.getDaysOfDayWeek(),
                firstDay: 1
            }
        }, callback);
    }

    getTranslate(s: string) {
        if (!this.isNullOrUndefined(s)) {
            return this.translate.instant(s);
        }
    }

    toggleLoader(b: boolean) {
        if (!b) {
            $('#loaderBox').fadeOut();
        } else {
            $('#loaderBox').fadeIn();
        }
    }

    isEMailValid(strEmail) {
        const str = strEmail;
        const exp = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i;
        const testResult = exp.test(str);
        if (!testResult) {
            this.showMessage(this.translate.instant('baseComponent.warningAttention'), this.translate.instant('baseComponent.warningMsgEmail'), 'warning');
        }
        return testResult;
    }

    getStatusColors(s: string) {
        switch (s) {
            case 'approved':
                return '#87CC92';
            case 'approved_award':
                return '#87CC92';
            case 'awarded':
                return '#139828';
            case 'received':
                return '#B7B7B7';
            case 'denied':
                return '#FF0000';
            case 'denial':
                return '#FF0000';
            case 'analysis':
                return '#FAE100';
            case 'finished':
                return '#2199E8';
            default:
                return '#B7B7B7';

        }
    }


    downloadHandlerFile(e, id = '#btnDownload') {
        const blob = new Blob([e], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        $(id).attr('href', url);
        setTimeout(() => {
            $('#btnDownload')[0].click();
        });
    }

    getObjectLocaleDatePicker() {
        return {
            customRangeLabel: 'Personalizar',
            format: 'DD/MM/YYYY',
            separator: ' - ',
            applyLabel: 'Aplicar',
            cancelLabel: 'Cancelar',
            daysOfWeek: [
                'Dom',
                'Seg',
                'Ter',
                'Qua',
                'Qui',
                'Sex',
                'Sab'
            ],
            monthNames: [
                'Janeiro',
                'Fevereiro',
                'Março',
                'Abril',
                'Maio',
                'Junho',
                'Julho',
                'Agosto',
                'Setembro',
                'Outubro',
                'Novembro',
                'Dezembro'
            ],
            firstDay: 1
        };
    }

    setFilterLocal(s: string, o: any) {
        localStorage.setItem(s, JSON.stringify(o));
    }

    getFilterLocal(s: string) {
        return localStorage.getItem(s);
    }

}
